import { render } from "./refferals-list.vue?vue&type=template&id=77a57a14"
import script from "./refferals-list.vue?vue&type=script&lang=js"
export * from "./refferals-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__